import request from '@/router/axios';
export const add = (row) => {
  return request({
    url: '/api/produce/stock-lease/insert',
    method: 'post',
    data: row
    })
  }
  // 变更
  export const update = (row) => {
  return request({
    url: '/api/produce/stock-lease/change/insert',
    method: 'post',
    data: row
    })
  }
  export const getDetail = (id) => {
  return request({
    url: '/api/produce/stock-lease/select/id',
    method: 'get',
    params: {
    id
    }
  })
  }
  export const getList = (params) => {
  return request({
    url: '/api/produce/stock-lease/select/page',
    method: 'get',
    params
  })
  }
  export const remove = (ids) => {
  return request({
    url: '/api/produce/stock-lease/delete/ids',
    method: 'get',
    params: {
      ids
    }
  })
  }

// 租约变更记录
export const getChangeLog = (params) => {
  return request({
    url: '/api/produce/lease-change-log/select/page',
    method: 'get',
    params
  })
}

// 仓库列表
export const getStoreList = () => {
  return request({
    url: '/api/produce/store/select/distinct/pycode',
    method: 'post',
    data: {}
  })
}

// 库位列表
export const getLocationList = (storeNo) => {
  return request({
    url: '/api/produce/store-sub/select/getLocationByStoreNo',
    method: 'get',
    params: { storeNo }
  })
}

// 附件上传地址（复用通用OSS）
export const uploadEndpoint = "/api/blade-resource/oss/endpoint/put-file-attach";

